import * as Sentry from '@sentry/browser'

declare global {
    interface Window {
        __SENTRY_DATA__: {
            dsn: string,
            environment: string,
            locale: string,
            user: never,
            release: string,
        }
    }
}

Sentry.init({
    dsn: window.__SENTRY_DATA__.dsn,
    environment: window.__SENTRY_DATA__.environment,
    beforeSend: event => {
        const userAgent = event.request!.headers!['User-Agent']
        const appVersion = userAgent.split('/').splice(1).join('/')

        if (userAgent.indexOf('MSIE') !== -1 || appVersion.indexOf('Trident/') > -1) {
            return null
        }

        return event
    },
    ignoreErrors: [
        'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection',
    ],
    release: `shift-one@${window.__SENTRY_DATA__.release}`,
})

Sentry.setTag('page_locale', window.__SENTRY_DATA__.locale)
Sentry.setExtra('user', window.__SENTRY_DATA__.user)
